import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { classNames } from "@/react/helpers/twMergeWithCN";

export interface UserCardBlockProps extends ComponentPropsWithRef<"div"> {
  description: ReactNode;
  header: ReactNode;
  image: ReactNode;
}

export const UserCard = forwardRef<HTMLDivElement, UserCardBlockProps>(
  ({ image, header, description, className, ...rest }, ref) => (
    <div
      ref={ref}
      className={classNames("wb-flex wb-items-center wb-gap-4", className)}
      {...rest}
    >
      <div className="wb-flex wb-items-center wb-justify-center">{image}</div>
      <div className="wb-flex wb-flex-col">
        {header}
        {description}
      </div>
    </div>
  ),
);

UserCard.displayName = "UserCard";
